import React, { Component, Fragment } from 'react';
import get from 'lodash/get';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withLocaleAwareIframe from 'pages/utils/withLocaleAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';

class RegisterRules extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const id = get(this.props, 'match.params.id');

    let page = '';
    if (id) {
      page = `/view/${id}`;
    }

    return (
      <Fragment>
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `.react-page { height: 100% }`,
          }}
        />
        <iframe
          title="Register Rules"
          src={`/webapps_redirect.php?app=retail-register-rules&next=${encodeURIComponent(
            `${page}${window.location.search}`
          )}`}
          style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        />
      </Fragment>
    );
  }
}

export default withLocalizeAwareIframe(
  withLocaleAwareIframe(withRouteAwareIframe(withValidSessionIframe(RegisterRules)))
);
